import axios from 'axios'
import React, { useEffect,useState } from 'react'
import {Container} from "reactstrap"
import { API_CANDIDATE } from '../../../utils/config'
import { Link } from 'react-router-dom'

import {
 
  getProfileInfo,
} from "../../../redux/action/profileInfoAction";
import { connect } from "react-redux";


// view uploaded resume component 
 function ViewUploadedResume(props) {

const [viewData,setViewData] = useState([])

useEffect(() => {
  props.getProfileInfo()

}, [])

// function for fetch uploaded resume












    return (
        <div>
          <Container>
    <div style={{ width: "100%" }}>
         <iframe
           src={
             `${API_CANDIDATE}/v1/api/view-uploaded-resume`
           }
           width="100%"
           height="600rem"
         ></iframe>
       </div>
     </Container>
    </div>
    )
}

const mapStateToProps = (state) => ({
  profile: state.profile,
});

export default connect(mapStateToProps,{getProfileInfo})(ViewUploadedResume) 
